import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import './index.css';
import HomePage from './pages/Home/HomePage';
import NotFoundPage from './pages/NotFound/NotFoundPage';

const App: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route component={HomePage} exact path="/" />
        <Route component={NotFoundPage} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  );
};

export default App;
